/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/**
 * Removes the Google reCAPTCHA badge.
 *
 * @return {void} This function does not return a value.
 */
export function removeRecaptchaBadge() {
    const nodeBadge = document.querySelector('.grecaptcha-badge');

    if (nodeBadge && nodeBadge.parentNode) {
        document.body.removeChild(nodeBadge.parentNode);
    }
}
